import axios from 'axios';

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/+$/, '') || '/api';

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const isLoginRequest = url.includes('/auth/login');
    const token = localStorage.getItem('auth_token');
    if (token && !isLoginRequest) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const farmaciaId = localStorage.getItem('farmacia_id') || localStorage.getItem('empresa_id');
    if (farmaciaId && !isLoginRequest) {
      config.headers['X-Farmacia-ID'] = farmaciaId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Se receber 401 (Unauthorized), fazer logout
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('farmacia_id');
      localStorage.removeItem('empresa_id');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
